import script from "./Fase4Transferencia.vue?vue&type=script&setup=true&lang=ts"
export * from "./Fase4Transferencia.vue?vue&type=script&setup=true&lang=ts"

import "./Fase4Transferencia.vue?vue&type=style&index=0&id=19d0f174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d0f174"]])

export default __exports__